import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "loginRegisterModalHeadlineId",
  tabindex: "-1",
  class: "z-11 absolute left-0 top-0 m-0 h-[5.14285714rem] w-full border-b-2 border-gray-40 bg-white p-4 text-[2rem] font-semibold leading-[2.714285714rem] lg:static lg:border-b-0 lg:pt-8 lg:text-center"
}
const _hoisted_2 = { class: "mx-auto block max-w-[400px] lg:max-w-[unset]" }

import { store } from "@/state/store";
import useIsMobile from "@/services/detectingMobile";
import { $t } from "@/main";


export default /*@__PURE__*/_defineComponent({
  __name: 'HeadlineModalMobil',
  setup(__props) {

const { isMobile } = useIsMobile();

return (_ctx: any,_cache: any) => {
  return (_unref(isMobile) && !_unref(store).isLandingPage)
    ? (_openBlock(), _createElementBlock("h2", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref($t)(_unref(store).isLogin ? "login.headline" : "registration.headline")), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})